import React, { useEffect } from 'react';
import ReportBreadcrumb from './ReportBreadcrumb';
import generateCrumbs from '../../utils/reports/generateCrumbs';
import __ from '../../utils/translator';
import calculatePercentage from '../../utils/reports/calculatePercentage';
import AccordionPrefix from './AccordionPrefix';
import mapObject from '../../utils/reports/mapObject';
import groupBy from 'lodash.groupby';
import Accordion from './Accordion';
import AccordionTitle from './AccordionTitle';
import generateReportUrl from '../../utils/reports/generateReportUrl';
import AccordionItemContainer from './AccordionItemContainer';
import AccordionItem from './AccordionItem';
import sortAlphabetically from '../../utils/reports/sortAlphabetically';
import RenderOnTablet from "../responsive/RenderOnTablet";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import { withTheme } from "styled-components";
import RenderOnMobile from "../responsive/RenderOnMobile";
import { default as MinusIcon } from "../../icons/Minus";
import { default as PlusIcon } from "../../icons/Plus";
import { default as ArrowRightThinIcon } from "../../icons/ArrowRightThin";
import ModalFullscreenActions from "../../flux/ModalFullscreenActions";
import { ItemLabel, TitleLabel } from "./ReportsLabels";
import NoResults from "../NoResults";

export default withTheme(({
  match,
  isLoading,
  data,
  ...props
}) => {
  return (
    <React.Fragment>
      <RenderOnTablet>
        <ReportBreadcrumb crumbs={generateCrumbs(match.params, __)} />
        <AccordionPrefix columns={['70%', '20%', '10%']}>
          <span>{__('Name')}</span>
          <span>{__('Content done')}</span>
          <span />
        </AccordionPrefix>
      </RenderOnTablet>

      {mapObject(sortAlphabetically(groupBy(data, 'region_code'), __), (regionData, region) => (
        <Accordion key={region}>
          <div style={{ boxShadow: themeResponsiveProperty('0px 0px 4px rgba(0, 0, 0, 0.25)', null)(props) }}>
            <AccordionTitle
              to={generateReportUrl(match.params.collectionType, {
                ...match.params,
                region: match.params.region === region ? undefined : region,
              })}
              isExpanded={match.params.region === region}
              columns={themeResponsiveProperty(['70%', '15%', '5%'], ['70%', '20%', '10%'])(props)}
              replace
            >
              <TitleLabel>
                {__(region)}
              </TitleLabel>

              <TitleLabel>
                {calculatePercentage(regionData)}%
              </TitleLabel>

              <RenderOnMobile>
                <span style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}>
                {match.params.region === region ? (
                  <MinusIcon style={{ width: '1rem' }} />
                ) : (
                  <PlusIcon style={{ width: '1rem' }} />
                )}
                </span>
              </RenderOnMobile>

              <RenderOnTablet>
                <span style={{
                  fontSize: '.875rem',
                  textAlign: 'right',
                  textTransform: 'uppercase',
                }}>
                  {match.params.region === region ? __('Close') : __('Expand')}
                </span>
              </RenderOnTablet>

            </AccordionTitle>

            <AccordionItemContainer isVisible={match.params.region === region}>
              {mapObject(sortAlphabetically(groupBy(regionData, 'country'), __), (countryData, country) => (
                <AccordionItem
                  key={country}
                  to={generateReportUrl(match.params.collectionType, {
                    ...match.params,
                    country,
                  })}
                  columns={themeResponsiveProperty(['70%', '15%', '5%'], ['70%', '20%', '10%'])(props)}
                >
                  <ItemLabel>
                    {country}
                  </ItemLabel>
                  <ItemLabel>
                    {calculatePercentage(countryData)}%
                  </ItemLabel>
                  <span style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                  }}>
                    <RenderOnMobile>
                      <ArrowRightThinIcon style={{ width: '.625rem' }} />
                    </RenderOnMobile>
                  </span>
                </AccordionItem>
              ))}
            </AccordionItemContainer>
          </div>
        </Accordion>
      ))}

      {isLoading === false && data.length === 0 && (
        <NoResults message={
          match.params.region !== undefined ? (
            __('No results for the selected region.')
          ) : (
            __('No results for the selected collection.')
          )}
        />
      )}
    </React.Fragment>
  );
});
